/*  ========================================================================
    # Pages - 404
    ========================================================================  */

// Dependencies
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const FourOhFour = () => {
  return (
    <>
      <Helmet>
        <title>404</title>
      </Helmet>

      <motion.main
        className='p-404'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <h1>404</h1>
        <p>
          <strong>Seite nicht gefunden.</strong>
        </p>
      </motion.main>
    </>
  );
};

export default FourOhFour;
